import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"
import {PaymentCompletedImage} from "@indebted/assets"
import {Props, Prop, PropValue, PropLabel} from "@indebted/components/Props"

function SettledAllAccounts({ClientName, CustomerName}: {ClientName: string; CustomerName: string}) {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.settled.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center">
					{t("customer_get.settled.message", {CustomerName: CustomerName})}
				</Typography>
			</Grid>

			<GridImage>
				<PaymentCompletedImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">{t("customer_get.settled.payment_details.paid_to.label")}</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {SettledAllAccounts}
